import type { OAISchema } from '~/types/openapi';
import numberToKorean from '~/utils/numToKorean';

// [TODO] 첫구매 기능 이후 리팩토링예정
export const genCouponTitle = (
  coupon: OAISchema['MarketBuyerCouponResponse'],
) => {
  // 고정 금액 할인
  if (
    coupon.discountType &&
    coupon.discountAmount &&
    coupon.discountType === 'FIXED'
  ) {
    return `${coupon.discountAmount.toLocaleString()}원 할인`;
  }

  // 비율 할인
  if (
    coupon.discountType &&
    coupon.discountRatio &&
    coupon.discountType === 'PERCENT'
  ) {
    return `${coupon.discountRatio}% 할인`;
  }

  return '알 수 없는 쿠폰';
};

export const genCouponHelpText = (
  coupon: OAISchema['MarketBuyerCouponResponse'],
) => {
  if (!coupon.minimumOrderAmount) return '';

  return coupon.maximumDiscountAmount
    ? `${numberToKorean(
        coupon.minimumOrderAmount,
      )}원 이상 주문시 / 최대 ${numberToKorean(
        coupon.maximumDiscountAmount,
      )}원 할인`
    : `${numberToKorean(coupon.minimumOrderAmount)}원 이상 주문시`;
};

export const calcTotalCouponPrice = (
  coupons: OAISchema['MarketCheckoutBuyerCouponResponse'][],
  selectedCouponId: number | null,
) =>
  selectedCouponId
    ? coupons.reduce((prev, coupon) => {
        if (selectedCouponId !== coupon.buyerCouponId!) return prev;

        return prev + coupon.calculatedDiscountAmount!;
      }, 0)
    : 0;

export const checkIsCouponDownloadable = ({
  couponStatus,
  isIssued,
}: OAISchema['MarketDownloadCouponResponseV2']) => {
  // 쿠폰이 비활성화 및 종료된 경우
  if (
    couponStatus === 'AWAITING' || // 쿠폰 진행 기간 이전 상태
    couponStatus === 'INACTIVE' || // 쿠폰 활성화버튼을 누르지 않은 상태
    couponStatus === 'ENDED' // 쿠폰 진행 기간 이후 상태
  ) {
    return false;
  }

  // 쿠폰이 발행된 경우
  if (isIssued) {
    return false;
  }

  return true;
};
